import { render, staticRenderFns } from "./manual-detail.vue?vue&type=template&id=6c1ac174&scoped=true&"
import script from "./manual-detail.vue?vue&type=script&lang=js&"
export * from "./manual-detail.vue?vue&type=script&lang=js&"
import style0 from "./manual-detail.vue?vue&type=style&index=0&id=6c1ac174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ac174",
  null
  
)

export default component.exports